import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getFileTypes as onGetFileTypes,
    addNewFileType as onAddNewFileType,
    updateFileType as onUpdateFileType,
    deleteFileType as onDeleteFileType,

    getDepartments as onGetDepartments,


} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const FileType = () => {

    //meta title
    document.title = "Types de fichiers | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [fileType, setFileType] = useState(null);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uid: (fileType && fileType.uid) || '',
            name: (fileType && fileType.name) || '',
            
        },
        validationSchema: Yup.object({
           
            name: Yup.string().required("Veuillez saisir le name"),
            
  
        }),
        onSubmit: (values) => {

            if (isEdit) {
                
                const updateFileType = {
                    //id: values.id,
                    uid: values.uid,
                    name: values.name,
                    
                    
                };
               
                dispatch(onUpdateFileType(updateFileType));
                validation.resetForm();
            } else {
                const newFileType = {
                    //id: values["id"],
                    //uid: values["uid"],
                    name: values["name"],
                   
                   
                };
                

                console.log("ON NEW: ", newFileType);
                dispatch(onAddNewFileType(newFileType));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const FileTypeProperties = createSelector(
        (state) => state.fileTypeReducer, // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
        (fileTypeReducer) => ({
            fileTypes: fileTypeReducer.fileTypes,
            loading: fileTypeReducer.loading
        })
    );

    const {fileTypes, loading} = useSelector(FileTypeProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {
        if (fileTypes && !fileTypes.length) {
            dispatch(onGetFileTypes());
        }
    }, [dispatch, fileTypes]);


    


    const toggle = () => {
        if (modal) {
            setModal(false);
            setFileType(null);
        } else {
            setModal(true);
        }
    };

    const handleFileTypeClick = arg => {
        const fileType = arg;
        setFileType({
            //id: serialeventCategory.id,
            uid: fileType.uid,
            name: fileType.name,
            
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (branch) => {
        setFileType(branch);
        setDeleteModal(true);
    };

    const handleDeleteFileType = () => {
        if (fileType && fileType.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteFileType(fileType));
            setDeleteModal(false);
        }
    };

    const onClickNewFileType = () => {
        setIsEdit(false);
        setFileType(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Nom",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleFileTypeClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteFileType}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Types de fichiers" breadcrumbItem="Liste des types de fichiers" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewFileType} className="btn btn-primary me-1">Ajouter un type de fichier</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={fileTypes || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Filière" : "Ajouter - Filière"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                        
                                        <div className="mb-3">
                                            <Label>Nom</Label>
                                            <Input
                                                name="name"
                                                type="text"
                                                placeholder="Nom"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.name || ""}
                                                invalid={
                                                    validation.touched.name && validation.errors.name ? true : false
                                                }
                                            />
                                            {validation.touched.name && validation.errors.name ? (
                                                <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                            ) : null}
                                        </div>

                                        

                                       
                                       
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default FileType;